import * as React from "react";

function SvgOrdersFilled(props) {
  return <svg viewBox="0 0 42 35" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7.637.25L3.471 4.417H.167v4.166h5.029l5.387-5.387L7.637.25zm7.113 4.167v4.166h27.083V4.417H14.75zM7.637 12.75l-4.166 4.167H.167v4.166h5.029l5.387-5.387-2.946-2.946zm7.113 4.167v4.166h27.083v-4.166H14.75zM4.333 28.375a3.125 3.125 0 100 6.25 3.125 3.125 0 000-6.25zm10.417 1.042v4.166h27.083v-4.166H14.75z" /></svg>;
}

export default SvgOrdersFilled;